export const fontSizes = {
  smxs: '0.813rem',
};
